// 公告附件（{name, url, ext, size}）类型判断与分类

// 可直接作为图片展示的扩展名
const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg']

// 取附件扩展名：优先用接口返回的 ext，缺失时从 url 后缀推断，统一小写
export function getFileExt (file) {
  if (!file) return ''
  let ext = file.ext ? String(file.ext) : ''
  if (!ext) {
    const matched = /\.([a-z0-9]+)(?:\?|#|$)/i.exec(file.url || '')
    ext = matched ? matched[1] : ''
  }
  return ext.toLowerCase().replace(/^\./, '')
}

// 是否图片附件
export function isImageFile (file) {
  return IMAGE_EXT.indexOf(getFileExt(file)) > -1
}

// 是否 PDF 附件
export function isPdfFile (file) {
  return getFileExt(file) === 'pdf'
}

// 过滤掉没有地址的无效附件
export function validFiles (files) {
  return (files || []).filter(file => file && file.url)
}

// 附件拆成「图片」与「其它文件（pdf 等）」两类
export function splitFiles (files) {
  const list = validFiles(files)
  return {
    images: list.filter(isImageFile),
    docs: list.filter(file => !isImageFile(file))
  }
}

// 字节数转可读大小（接口未返回 size 时返回空串）
export function formatFileSize (size) {
  const bytes = Number(size)
  if (!bytes || bytes < 0) return ''
  if (bytes < 1024) return bytes + 'B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'KB'
  return (bytes / 1024 / 1024).toFixed(1) + 'MB'
}

// 打开附件：pdf 等文件交由系统/微信内置浏览器打开
export function openFile (url) {
  if (!url) return
  window.open(url)
}



// WEBPACK FOOTER //
// ./src/common/js/annex.js